import { BaseModel } from "sjs-base-model";

export default class ActorReferenceModel extends BaseModel {
  public readonly uuid: string = "";
  public readonly created: string = "";
  public readonly modified: string = "";
  public readonly name: string = "";
  public readonly title: string = "";
  public readonly email: string = "";
  public readonly phone_number: string = "";
  public readonly profile: string = "";

  /*
   * Client-Side properties (Not from API)
   */
  // public noneApiProperties: unknown = null;

  constructor(data: Partial<ActorReferenceModel>) {
    super();

    this.update(data);
  }
}
